import {
  FirstCellRenderer,
  OverallCellRenderer,
  MainCellRenderer,
  CoreCellRenderer,
} from './CellConfig'

export const formatRows = (
  data,
  header,
  access,
  prevRows,
  locationGroupsLength,
  corporateHierarchy
) => {
  let rows = []
  if (data && data.length) {
    let moduleParent = null
    let moduleParentId = null
    const dataLocationCount = data.filter(
      (item) => item.module === 'location'
    ).length

    data.map((item) => {
      item.module === 'location' ? (moduleParent = item.name) : null //eslint-disable-line
      item.module === 'location' ? (moduleParentId = item.module_id) : null //eslint-disable-line
      let moduleData = {}

      header.map((headerItem, index) => {
        moduleData[headerItem.headerName] = {}
        moduleData[headerItem.headerName]['name'] = item.module_data[index - 1]
          ? item.module_data[index - 1].name
          : null
        moduleData[headerItem.headerName]['date'] = item.module_data[index - 1]
          ? item.module_data[index - 1].date
          : null
        moduleData[headerItem.headerName]['isExternalReport'] = item
          .module_data[index - 1]
          ? item.module_data[index - 1].isExternalReport
          : null
        moduleData[headerItem.headerName]['status'] = item.module_data[
          index - 1
        ]
          ? item.module_data[index - 1].status
          : null
        moduleData[headerItem.headerName]['checklistStatus'] = item.module_data[
          index - 1
        ]
          ? item.module_data[index - 1].checklist_status
          : null
        moduleData[headerItem.headerName]['courseId'] = item.module_data[
          index - 1
        ]
          ? item.module_data[index - 1].course_id
          : null
        moduleData[headerItem.headerName]['equivalent'] = item.module_data[
          index - 1
        ]
          ? item.module_data[index - 1].equivalent
          : null
        moduleData[headerItem.headerName]['requireChecklistCompletion'] =
          item.module_data[index - 1] &&
          item.module_data[index - 1].requireChecklistCompletion
            ? item.module_data[index - 1].requireChecklistCompletion
            : false
        moduleData[headerItem.headerName]['requireChecklist'] =
          item.module_data[index - 1] &&
          item.module_data[index - 1].requireChecklist
            ? item.module_data[index - 1].requireChecklist
            : false
        moduleData[headerItem.headerName]['group_id'] =
          item.module_data[index - 1] && item.module_data[index - 1].group_id
            ? item.module_data[index - 1].group_id
            : false
        moduleData[headerItem.headerName]['waiting_for_approval'] =
          item.module_data[index - 1] &&
          item.module_data[index - 1].waitingForApproval
            ? item.module_data[index - 1].waitingForApproval
            : false
        moduleData[headerItem.headerName]['quizPassedPercentage'] =
          item.module_data[index - 1] &&
          item.module_data[index - 1].status &&
          (item.module_data[index - 1].status === 4 ||
            item.module_data[index - 1].status === 2)
            ? item.module_data[index - 1].quizPercentage
            : false
      })

      rows.push({
        module: item.module,
        moduleName: item.name,
        moduleId: item.module_id,
        moduleParentId: moduleParentId,
        moduleSubName: item.module === 'location' ? item.module_sub_name : null,
        jobTitles: item.job_titles,
        moduleParent: item.module === 'employee' ? moduleParent : null,
        isActive:
          item.module === 'location'
            ? access === 0 && locationGroupsLength === 0
              ? true
              : false
            : null,
        isShowing:
          access === 0 && locationGroupsLength === 0
            ? true
            : item.module === 'employee'
            ? false
            : true,
        ...moduleData,
        date: item.date,
      })
    })
  }

  if (prevRows && prevRows.length) {
    const prevRowsLocations = prevRows.filter(
      (item) => item.module === 'location'
    )
    const prevRowsLocationsIds = prevRowsLocations.map((item) => item.moduleId)

    rows.map((item) => {
      if (
        prevRowsLocationsIds.includes(item.moduleParentId) &&
        item.moduleName !== 'Corporate' &&
        !item.moduleSubName &&
        !corporateHierarchy
      ) {
        const prevSingleItem = prevRows.find(
          (prevItem) =>
            prevItem.moduleId === item.moduleId &&
            prevItem.moduleParentId === item.moduleParentId
        )
        if (prevSingleItem) {
          prevSingleItem.isActive ? (item.isActive = true) : null //eslint-disable-line
          prevSingleItem.isShowing ? (item.isShowing = true) : null //eslint-disable-line
        }
      }
    })
  }

  return rows
}

export const formatColumns = (data) => {
  const formatedData = []

  formatedData.push({
    headerName: '',
    field: 'moduleName',
    suppressMovable: true,
    pinned: 'left',
    tooltipField: 'moduleName',
    cellRenderer: FirstCellRenderer,
  })

  if (data) {
    data.map((item) => {
      const itemName = item.name.split(' ')[0]

      itemName === 'Overall'
        ? formatedData.push({
            headerName: item.name,
            field: item.name,
            suppressMovable: true,
            // pinned: 'left',
            tooltipField: item.name + ' ',
            cellRenderer: OverallCellRenderer,
            cellStyle: { 'text-align': 'center' },
          })
        : itemName === 'Core'
        ? formatedData.push({
            headerName: item.name,
            field: item.name,
            suppressMovable: true,
            pinned: 'left',
            width: 90,
            tooltipField: item.name + ' ',
            cellRenderer: CoreCellRenderer,
            cellStyle: { 'text-align': 'center' },
          })
        : formatedData.push({
            headerName: item.name,
            field: item.name,
            suppressMovable: true,
            cellRenderer: MainCellRenderer,
            cellStyle: { 'text-align': 'center' },
          })
    })
  }

  return formatedData
}
